<template>
  <div class="bpmVisual js-bpmVisual" :style="{ height: height }">
    <div class="bpm">
      <div class="first-level-node start">
        <div class="first-level-node-item">开始</div>
      </div>
      <div v-for="item in bpmData" :key="item.id" class="first-level-node">
        <div class="first-level-node-item" @click="handleBpmNode(item)">
          <el-checkbox
            v-if="showSeledCheck(item, 1)"
            :disabled="isDisabled(item)"
            class="bpm-checkout"
            :value="isCurSelect(item)"
            @change="selectNode(item)"
          ></el-checkbox>
          <span>{{ item.label }}</span>
          <span v-if="isSelected(item)" class="first-active-warpper">
            <span class="isActive" />
          </span>
        </div>

        <i
          v-if="showTipIcon(item)"
          class="layui-icon bpm-bz-first"
          @click.stop
          @mouseover="tipMoreOver($event, item)"
          @mouseout="tipMoreOut($event, item)"
          >&#xe60b;</i
        >

        <div v-for="j in item.children" :key="j.id" class="second-level-node">
          <div class="secondLine" />

          <div class="second-level-node-item" @click="handleBpmNode(j)">
            <el-checkbox
              v-if="showSeledCheck(j, 2)"
              :disabled="isDisabled(j)"
              class="bpm-checkout"
              :value="isCurSelect(j)"
              @change="selectNode(j)"
            ></el-checkbox>
            <span>{{ j.label }}</span>
            <span v-if="isSelected(j)" class="second-active-warpper">
              <span class="isActive" />
            </span>
          </div>

          <i
            v-if="showTipIcon(j)"
            class="layui-icon bpm-bz"
            @click.stop
            @mouseover="tipMoreOver($event, j)"
            @mouseout="tipMoreOut($event, j)"
            >&#xe60b;</i
          >

          <div v-for="k in j.children" :key="k.id" class="third-level-node">
            <div class="thirdLine" />

            <div class="third-level-node-item" @click="handleBpmNode(k)">
              <el-checkbox
                v-if="showSeledCheck(k, 3)"
                :disabled="isDisabled(k)"
                class="bpm-checkout"
                :value="isCurSelect(k)"
                @change="selectNode(k)"
              ></el-checkbox>
              <span>{{ k.label }}</span>
              <span v-if="isSelected(k)" class="third-active-warpper">
                <span class="isActive" />
              </span>
            </div>

            <i
              v-if="showTipIcon(k)"
              class="layui-icon bpm-bz"
              @click.stop
              @mouseover="tipMoreOver($event, k)"
              @mouseout="tipMoreOut($event, k)"
              >&#xe60b;</i
            >
          </div>
        </div>
      </div>
      <div class="first-level-node end">
        <div class="first-level-node-item end">结束</div>
      </div>
      <save-bz :visible.sync="save" :nodeitem="nodeitem" @save="handleNodeSave" @cancel="handleNodeCancel" />
    </div>
  </div>
</template>

<script>
import saveBz from './saveBz'

/**
 * @typedef BpmNode
 * @property {string} id
 * @property {string} label
 * ~@property {boolean} active~
 * @property {string} bz
 * @property {string} field
 * @property {BpmNode[]=} children
 */
/**
 * @typedef {...import('./addBpm.vue').CmpType|'select'} CmpType
 * - select 选择节点
 */

/** Bpm 编辑区 */
export default {
  name: 'Bpm_Visual',
  // inject: ['source'],
  props: {
    type: {
      type: String,
      default: 'add'
    },
    height: { type: String, default: '' },
    /**
     * 历史选择
     * @type {{id: string|number, any}[]}
     */
    selected: { type: Array, default: () => [] },
    /**
     * 本次选择
     * @type {(string|number)[]}
     */
    currentSelect: { type: Array, default: () => [] },
    /** @type {BpmNode[]} */
    bpmData: {
      type: Array,
      default: () => []
    },

    /** 外部处理禁用逻辑：节点选择器 */
    isDisabledFn: { type: Function }
  },
  components: {
    saveBz
  },
  data() {
    return {
      /** 所有节点库节点信息 */
      nodesInfo: {},
      /** 当前编辑 Node */
      nodeitem: {},
      save: false
      // selectNodes: [],
    }
  },
  mounted: function() {
    this.getNodesInfo()
  },
  methods: {
    /** 是否展示提示信息 ICON */
    showTipIcon: function(node) {
      return node.bz || (this.nodesInfo[node.id] || {}).NODE_REMARKS
    },
    /**
     * 是否可选编辑 - 显示选中框
     */
    showSeledCheck: function(node, level) {
      // 分配叶子节点
      // return this.type === 'select' && !(node.children || []).length
      // 分配三级节点
      return this.type === 'select' && level == 3
    },
    isDisabled: function(node) {
      return this.isDisabledFn ? this.isDisabledFn({ node: node, sourceFn: this.isSelected }) : this.isSelected(node)
    },
    /** 是否已被选中 */
    isSelected: function(node) {
      return !!this.selected.filter(n => node.id == n.id).length
    },
    isCurSelect: function(node) {
      return !!this.currentSelect.filter(n => n == node.id).length
    },

    tipMoreOver: function(ev, iData) {
      let gNode = this.nodesInfo[iData.id] || {}
      ev.currentTarget.tip = this.layer.tips(
        // ['全局：', gNode.NODE_REMARKS || '', '本流程：', iData.bz || ''].filter(v => v).join('<br>'),
        [gNode.NODE_REMARKS ? `节点库：${gNode.NODE_REMARKS}` : '', iData.bz ? `本流程：${iData.bz}` : '']
          .filter(v => v)
          .join('<br>'),
        ev.currentTarget,
        { time: 0 }
      )
    },
    tipMoreOut: function(ev, iData) {
      layui.layer.close(ev.currentTarget.tip)
    },
    /** 点击 Bpm 节点 */
    handleBpmNode(params) {
      if (['add', 'edit'].indexOf(this.type) > -1) {
        this.nodeitem = Object.assign(params, {
          gNode: this.nodesInfo[params.id] || {},
          // 需要备份的字段
          origin: { bz: params.bz, fileId: params.fileId, imgId: params.imgId }
        })
        this.save = true
      }
    },
    /** 节点编辑：保存 */
    handleNodeSave: function() {
      this.save = false
      let nodeitem = this.nodeitem
      delete nodeitem.gNode
      delete nodeitem.origin
    },
    /** 节点编辑：取消 */
    handleNodeCancel: function(e) {
      this.save = false
      let nodeitem = this.nodeitem
      let origin = nodeitem.origin
      // 恢复之前备份的字段值
      Object.assign(nodeitem, origin)
      delete nodeitem.gNode
      delete nodeitem.origin
      this.nodeitem = {}
    },

    selectNode(params) {
      let num = this.currentSelect.findIndex(item => item == params.id)
      if (num != -1) {
        this.currentSelect.splice(num, 1)
      } else {
        this.currentSelect.push(params.id)
      }
    },
    querySelect() {
      return this.currentSelect
    },

    /**
     * 获取所有 node 信息
     */
    getNodesInfo: function() {
      this.api.queryList('YW_FLOW_NODE', { p2: {}, p9: '' }, 'bpmGetNodeInfo').then(response => {
        var result = response.result

        let nodes = {}
        if (result.length > 0) {
          result.map(node => {
            nodes[node.NODE_ID] = node
          })

          this.nodesInfo = nodes
        }
      })
    },

    /**
     * 获取流程节点信息
     * - 为外部组件提供获取节点信息的接口
     * @param {{}} tplInfo 模板信息
     */
    getTplNodeInfo(tplInfo = {}) {
      let tplNode = tplInfo.data,
        gNodes = this.nodesInfo

      let totalBZ = [`${tplInfo.BZ || ''}`],
        totalFiles = [],
        MapClassFile = {}
      window.treeNodeAddProp(tplNode, { childrenProp: 'children' }, (node, pos) => {
        let gNode = gNodes[node.id] || {}

        // let str = []
        // if (gNode.NODE_REMARKS) str.push(gNode.NODE_REMARKS)
        // if (node.bz) str.push(node.bz)
        // if (str.length) {
        //   totalBZ.push(`【${node.label}】：${ str.join('。') }`)
        // }

        if (!MapClassFile[node.id]) {
          MapClassFile[node.id] = { node_name: node.label, files: [] }
        }
        if (gNode.NODE_FS) {
          totalFiles.push(gNode.NODE_FS)
          MapClassFile[node.id].files.push(gNode.NODE_FS)
        }
        if (node.fileId) {
          totalFiles.push(node.fileId)
          MapClassFile[node.id].files.push(node.fileId)
        }
        if (node.imgId) {
          totalFiles.push(node.imgId)
          MapClassFile[node.id].files.push(node.imgId)
        }

        return node
      })
      let tFiles = []
      Object.keys(MapClassFile).map(item => {
        let file = MapClassFile[item]
        if (file.files.length) {
          tFiles.push({ ...file, files: file.files.join(',') })
        }
      })

      return {
        totalBZ: totalBZ.join(''),
        totalFiles: totalFiles.join(','),
        /** 按节点分类的所有文件 */
        classFiles: tFiles || []
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/workOrder/bpm/bpm.vue